import { Button, Typography } from '@mui/material'
import tw from 'twin.macro'
import { ContractorPortalPublicWrapper } from 'src/components/layout/contractorPortal/ContractorPortalPublicWrapper'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import React, { useCallback, useMemo } from 'react'
import { CONTRACTOR_PORTAL_ROUTES } from 'src/constants/routes'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { useDispatch, useSelector } from 'react-redux'
import { getContractorPortalPartners } from 'src/selectors/contractorPortal'
import { ContractorPortalPartner } from 'src/interfaces/contractorPortal'
import { ContractorPortalPartnerItem } from 'src/components/contractor-portal/ContractorPortalPartnerItem'
import { ContractorPortalSignInPhone } from 'src/constants/actionTypes'
import { createAsyncAction } from 'src/utils/reduxUtils'

export const ContractorPortalSelectPartnerPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const contractorPortalPartners = useSelector(getContractorPortalPartners)

  const phone = useMemo(() => location?.state?.phone || '****', [location])

  const handleBack = useCallback(() => {
    navigate(CONTRACTOR_PORTAL_ROUTES.SIGN_IN_URL)
  }, [])

  const handleSelectPartner = useCallback(
    async (partner: ContractorPortalPartner) => {
      await createAsyncAction(
        dispatch,
        ContractorPortalSignInPhone.request({ phone, partnerName: partner.name }),
      )

      navigate(`/contractor/enter-code`, { state: { phone, partnerName: partner.name } })
    },
    [phone],
  )

  if (!location?.state?.phone || !contractorPortalPartners.length) {
    return <Navigate to={CONTRACTOR_PORTAL_ROUTES.NOT_FOUND_URL} />
  }

  return (
    <ContractorPortalPublicWrapper childrenClassName={tw`px-0`}>
      <div css={tw`px-4`}>
        <Button
          css={tw`bg-primary-100 h-[42px] w-[82px] hover:bg-primary-200`}
          onClick={handleBack}
          data-testid="header-nav-back-btn"
        >
          <div css={tw`items-center flex flex-row`}>
            <ChevronLeftMinor css={tw`fill-primary-500`} width={19} />
            <Typography css={tw`[font-weight: 600] text-primary-500`}>Back</Typography>
          </div>
        </Button>
        <Typography variant="h2" css={tw`mb-2 mt-6`}>
          Your phone number is linked to multiple partners
        </Typography>
        <Typography css={tw`mb-6 text-shades-400`}>Select the partner you want to view.</Typography>
      </div>
      {contractorPortalPartners.map((item) => (
        <ContractorPortalPartnerItem key={item.id} partner={item} onClick={handleSelectPartner} />
      ))}
    </ContractorPortalPublicWrapper>
  )
}
